import { useEffect, useState } from "react";
import ProductCard from "../../productCard";
import { fetchMasterCategories } from "../../../../node_modules/shops-query/src/modules/masterCategories";
import { getProductsController } from "../../../../node_modules/shops-query/src/modules/products/index.js";
import { getProductsByCategoryController } from "../../../../node_modules/shops-query/src/modules/productByCategory/index";
import { shopid } from "../../../utils/url";
import { Link } from "react-router-dom";

const TrendingNow = () => {
  const [isNullData, setIsNullData] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [products, setProducts] = useState([]);
  const [productsInSelectedCategory, setProductsInSelectedCategory] = useState(
    []
  );
  // const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const catData = await fetchMasterCategories(shopid);
        setCategories(catData);
      } catch (error) {
        console.log("Something went wrong while getting categories", error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await getProductsController(shopid, null);

        if (res?.data?.products) {
          setProducts(res.data.products);
        } else if (Array.isArray(res)) {
          setProducts(res);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error("An error occurred:", error);
        if (error?.response?.data?.data?.products) {
          setProducts(error.response.data.data.products);
        }
      }
    };

    fetchProducts();
  }, []);

  const getProductsByCategories = async (catName) => {
    try {
      setIsNullData(false);
      const catData = await getProductsByCategoryController(catName, shopid);
      if (!catData || catData.length === 0) {
        setIsNullData(true);
      }
      setProductsInSelectedCategory(catData);
    } catch (error) {
      console.log(
        "Something went wrong while fetching master categories",
        error
      );
    }
  };

  const handleCategoryClick = (c) => {
    getProductsByCategories(c.category);
    setSelectedCategory(c.category);
  };

  return (
    <div className="font-poppins mt-[40px] md:mt-[80px] w-full ">
      {/* Main container with responsive padding */}
      <div className="w-full mx-auto px-4 md:pl-16 md:pr-[4.5rem] ">
        {/* Header */}
        <div className="flex items-center justify-between md:pb-6 pb-2">
          <p className="font-medium text-[20px] sm:text-[24px] md:text-[28px] lg:text-[32px] uppercase">
            Trending now{" "}
          </p>

          <Link to="/all-products">
            <p className="font-semibold md:-ml-[20%] text-[14px] sm:text-[16px] md:text-[18px] uppercase underline underline-offset-2 cursor-pointer text-primary-default">
              View All
            </p>
          </Link>
        </div>

        {/* Categories - Horizontal scroll for mobile */}
        <div className="w-full overflow-x-auto scrollbar-hide">
          <div className="flex gap-4 sm:gap-6 md:gap-8 lg:gap-[32px] xl:gap-[56px] min-w-max py-2">
            <p
              className={`cursor-pointer whitespace-nowrap ${selectedCategory === "All"
                ? "text-neutral-black font-semibold"
                : "text-neutral-grey-2"
                } text-[14px] sm:text-[16px]`}
              onClick={() => setSelectedCategory("All")}
            >
              All
            </p>

            {categories?.map((item, index) => (
              <p
                key={index}
                className={`cursor-pointer whitespace-nowrap ${selectedCategory === item.category
                  ? "text-neutral-black font-semibold"
                  : "text-neutral-grey-2"
                  } text-[14px] sm:text-[16px]`}
                onClick={() => handleCategoryClick(item)}
              >
                {item.category}
              </p>
            ))}
          </div>
        </div>

        {/* Product Section */}
        <div className="pb-6 sm:pb-8 md:pb-12 lg:pb-20 md:mt-[24px] mt-[12px]">
          {selectedCategory === "All" ? (
            <>
              {/* MOBILE — Horizontal Scroll */}
              <div className="flex sm:hidden gap-4 overflow-x-auto scrollbar-hide">
                {products?.slice(0, 5).map((item) => (
                  <div
                    key={item?.id}
                    className="min-w-[45vw] sm:min-w-[180px] flex-shrink-0"
                  >
                    <ProductCard
                      item={item}
                      tag=""
                      showHeart={true}
                      isThisWishlistPage={false}
                    />
                  </div>
                ))}
              </div>

              {/* DESKTOP — Grid */}
              <div
                className="
    hidden sm:grid
    grid-cols-4
    gap-6
    w-full
  "
              >
                {products?.slice(0, 4).map((item) => (
                  <ProductCard
                    key={item?.id}
                    item={item}
                    tag=""
                    showHeart={true}
                    isThisWishlistPage={false}
                  />
                ))}
              </div>
            </>
          ) : isNullData ? (
            <div className="w-full flex justify-center items-center py-10">
              <p className="text-center text-neutral-grey-2 text-[16px] sm:text-[18px]">
                No Products Found
              </p>
            </div>
          ) : (
            <>
              {/* MOBILE CATEGORY — Horizontal Scroll */}
              <div className="flex sm:hidden gap-4 overflow-x-auto scrollbar-hide">
                {productsInSelectedCategory?.slice(0, 5).map((item) => (
                  <div
                    key={item?.id}
                    className="min-w-[45vw] sm:min-w-[180px] flex-shrink-0"
                  >
                    <ProductCard
                      item={item}
                      tag=""
                      showHeart={true}
                      isThisWishlistPage={false}
                    />
                  </div>
                ))}
              </div>

              {/* DESKTOP CATEGORY — GRID */}
              <div
                className="
                  hidden sm:grid
                  grid-cols-4
                  gap-6
                  w-full
                "
              >
                {productsInSelectedCategory?.slice(0, 4).map((item) => (
                  <ProductCard
                    key={item?.id}
                    item={item}
                    tag=""
                    showHeart={true}
                    isThisWishlistPage={false}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrendingNow;
